import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import SearchBar from "../../components/SearchBar";
import { Button } from "@mui/material";
import AddNotification from "../../Modals/addNotification";
import AddIcon from "@mui/icons-material/Add";
import NotificationsList from "../../features/manageNotifications/notificationsList";
import usePermission from "../../hooks/usePermission";
import { useLazyGetNotificationsQuery } from "../../services/notifications";
import { Notification } from "../../types/General";
import { isValidInput } from "../../utils/validations";

const ManageNotifications = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [allNotifications] = useLazyGetNotificationsQuery();
  const { isAdd, isView } = usePermission({
    label: "Manage Notifications",
    page_permission: "isView",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [rows, setRows] = useState<Notification[]>([]);

  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const getAllNotifications = async () => {
    setIsLoading(true);
    try {
      const response = await allNotifications({
        page,
        limit: 10,
        search: debouncedSearchTerm.trim(),
      }).unwrap();
      if (response?.statusCode === 200) {
        // setIsLoading(false);
        setRows(response?.data?.data || []);
        setCount(response?.data?.count);
      }
    } catch (error) {
      //   setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAllNotifications();
  }, [debouncedSearchTerm, page]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Notifications</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage
          Notifications
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              placeholder="Search..."
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />
          </div>
          {isAdd && (
            <div className="right_s">
              <Button
                className="btn btn_primary"
                onClick={() => setOpenModal(true)}
              >
                <AddIcon /> Add Notification
              </Button>
            </div>
          )}
        </div>

        {isView && (
          <NotificationsList
            isLoading={isLoading}
            getAllNotifications={getAllNotifications}
            rows={rows}
            count={count}
            page={page}
            handlePageChange={handlePageChange}
          />
        )}
      </div>

      <AddNotification
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
        getAllNotifications={getAllNotifications}
      />
    </MainContainer>
  );
};

export default ManageNotifications;
